import { Component, OnInit } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { ModalController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { Legal } from '../../../smoothr-web-app-core/models/Legal';
import { LegalService, LegalType } from '../../services/legal.service';
import { SignInModalComponent } from '../sign-in-modal/sign-in-modal.component';
import { SignUpModalComponent } from '../sign-up-modal/sign-up-modal.component';
import { UserDataModalComponent } from '../user-data-modal/user-data-modal.component';
import { FacebookPixelEvent } from '../../../smoothr-web-app-core/enums/facebook-pixel-event';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import {NavigationService} from "../../services/navigation.service";

enum Language {
	GreatBritain = 'en',
	German = 'de',
}

@Component({
	selector: 'app-menu-modal',
	templateUrl: './menu-modal.component.html',
	styleUrls: ['./menu-modal.component.scss'],
})
export class MenuModalComponent extends RepositoryDirective implements OnInit {
	environment = environment;
	languageEnum = Language;
	legal: Legal | null = null;
	public userName: string = '';

	constructor(
		public repository: RepositoryService,
		private modalController: ModalController,
		private snackbarCtrl: MatSnackBar,
		public translate: TranslateService,
		private legalService: LegalService,
		private analyticsService: AnalyticsService,
		private navSvc: NavigationService
	) {
		super(repository);
	}

	ngOnInit(): void {
		super.ngOnInit();
		if (this.customer?.name) {
			this.userName = this.customer.name.split(/[ _]+/)[0];
		}
		this.loadLegal();
	}

	private async loadLegal() {
		const legal = await this.legalService.getLegal();
		// only documents filled in the Back Office (PDF url or HTML text) are shown
		this.legal = legal && (legal.imprint || legal.privacy || legal.terms) ? legal : null;
		console.log('wwwwwwwwwwww', this.legal)
	}

	async openLegal(type: LegalType) {
		await this.dismiss();
		await this.legalService.open(type);
	}

	async signIn() {
		await this.dismiss();
		this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.Login);
		this.navSvc.signIn();
	}

	async signUp() {
		await this.dismiss();
		this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.Register);
		this.navSvc.signUp();
	}

	async account() {
		await this.dismiss();
		await UserDataModalComponent.show(this.modalController);
	}

	async logout() {
		try {
			this.repository.customerAuth.emit(null);
			// this.repository.obserableOrder.next(null);
			this.repository.previousPreorder.emit(null);
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_success'), null, {
				duration: 2000,
			});
			this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.Logout);
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_error'), null, {
				duration: 2000,
			});
		}
		await this.dismiss();
	}

	async dismiss() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
	}

	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
	}
}
